import { Route } from '@angular/router';
import { authGuard } from './feature-shell/feature-shell-guard/feature-shell.guard';

export const featureShellRoutes: Route[] = [
  {
    path: 'access-denied',
    title: 'PAGE_TITLE.ACCESS_DENIED',
    loadChildren: () => import('@frontend/feature-access-denied').then((m) => m.featureAccessDeniedRoutes),
  },
  {
    // Must come before 'categories' so ':categoryId' doesn't swallow the literal 'documents' segment
    path: 'categories/documents',
    loadChildren: () => import('@frontend/feature-search-documents').then((m) => m.featureSearchDocumentsRoutes),
  },
  {
    path: 'categories',
    loadChildren: () => import('@frontend/feature-category-page').then((m) => m.featureCategoryPageRoutes),
  },
  {
    path: 'categories/:categoryId/documents',
    loadChildren: () => import('@frontend/feature-filter-results').then((m) => m.featureFilterResultsRoutes),
  },
  {
    path: 'categories/:categoryId/documents/:documentId/:docuLanguage',
    loadChildren: () => import('@frontend/feature-document-details').then((m) => m.featureDocumentDetailsRoutes),
  },
  {
    path: 'categories/:categoryId/documents/:documentId',
    loadChildren: () => import('@frontend/feature-document-details').then((m) => m.featureDocumentDetailsRoutes),
  },
  {
    path: 'search',
    title: 'PAGE_TITLE.SEARCH',
    loadChildren: () => import('@frontend/feature-search-documents').then((m) => m.featureSearchDocumentsRoutes),
  },
  {
    path: 'favorites',
    title: 'PAGE_TITLE.FAVORITES',
    loadChildren: () => import('@frontend/feature-search-documents').then((m) => m.featureSearchDocumentsRoutes),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'categories',
    pathMatch: 'full',
  },
];
